<template>
    <hot-dropdown
      class="menu-notifications"
      slot="header-actions"
      @open="onOpenDropdown"
      @close="onCloseDropdown"
      tabindex="0"
      @keyup.enter="toggleTab"
      @keyup.space="toggleTab"
    >
      <hot-menu-item
        id="header-tips"
        class="dropdown-button _rounded-lg"
        :class="{'_bg-gray-200': isActive}"
        slot="button"
      >
        <accessible-icon
          class="hot-application-menu__icon"
          :class="{'_text-brand-primary': isActive}"
          iconName="question-circle"
          iconFamily="fal"
          :description="$t('header.tipsTab.title')"
        />
      </hot-menu-item>
      <div class="_py-2" slot="menu">
        <hot-dropdown-menu-header class="_text-2" slot="menu">{{$t('header.tipsTab.title')}}</hot-dropdown-menu-header>
        <div class="notifications-list _overflow-hidden">
          <hot-dropdown-menu-item v-for="({ title, duration }, index) in tips" :key="index" @click="openDialog(index)" class="_px-5 _line-height-sm _d-flex _align-items-center">
            <div class="notification-item-icon _bg-gray-300 _d-flex _justify-content-center _align-items-center _p-3 _rounded-lg _mr-3 _text-white">
              <font-awesome-icon :icon="['fal', 'play-circle']" size="2x"/>
            </div>
            <div class="_d-flex _justify-content-center _flex-column">
                <span class="menu-item-description _text-2" >
                    {{ title }}
                </span>
                <small class="_text-gray-500 _d-block _mt-1" v-if="duration">{{ duration }}</small>
            </div>
          </hot-dropdown-menu-item>
        </div>
        <div class="_d-flex _justify-content-center _pt-1">
          <button class="hot-button hot-button--tertiary" type="button" @click="openDialog()">
            {{$t('header.tipsTab.showAll')}}
          </button>
        </div>
      </div>
    </hot-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import formatDistance from 'date-fns/formatDistance'
import AccessibleIcon from 'core/components/AccessibleIcon/AccessibleIcon.vue'

export default {
  name: 'HeaderTips',
  components: {
    AccessibleIcon
  },
  computed: {
    ...mapState('userNotifications', ['tips'])
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    formatDateRelative (date) {
      const relativeDate = formatDistance(date, new Date(), {
        locale: this.localeData,
        addSuffix: true
      })

      return relativeDate.charAt(0).toUpperCase() + relativeDate.slice(1)
    },
    openDialog (id) {
      this.$event.emit('open:user-notifications-dialog', {
        type: 'tips',
        id: id
      })
    },
    onOpenDropdown () {
      this.closeNotificationsDialog()
      this.isActive = true
    },
    onCloseDropdown () {
      this.isActive = false
    },
    closeNotificationsDialog () {
      this.$event.emit('close:user-notifications-dialog')
    },
    toggleTab () {
      this.$emit('toggleTab', 'header-tips')
    }
  }

}
</script>

<style lang="scss" scoped>
    @import '~stylesheets/meta';
    @import '~stylesheets/base';

    .notifications-list {
      max-height: 260px;
    }

    .menu-notifications {
      --dropdown-menu-width: 480px;
    }

    .notification-item-icon {
        height: 56px;
    }

    .menu-item {
        height: 84px;
        max-height: 84px;
    }

    .menu-item-description {
        max-height: 48px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
